// Use environment variables or fallback based on environment
const getServerUrl = () => {
  // Wenn REACT_APP_SERVER_URL gesetzt ist, verwende diese
  if (process.env.REACT_APP_SERVER_URL) {
    return process.env.REACT_APP_SERVER_URL;
  }
  // Im Development-Modus localhost verwenden
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:5000";
  }
  // In Produktion die Produktions-URL
  return "https://auktion.ehckundl.at";
};

const SERVER_URL = getServerUrl();

export const API_BASE_URL = SERVER_URL;
export const SOCKET_URL = SERVER_URL;
